/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { BreadcrumbsDispatcher as SourceBreadcrumbsDispatcher } from 'SourceStore/Breadcrumbs/Breadcrumbs.dispatcher';
import {BRAND_CHANEL} from "../../route/ProductPage/ProductPage.config";
import { appendWithStoreCode } from 'Util/Url';

/**
 * Breadcrumbs Dispatcher
 * @class BreadcrumbsDispatcher
 * @namespace Store/Breadcrumbs/Dispatcher
 */
export class BreadcrumbsDispatcher extends SourceBreadcrumbsDispatcher {

    /**
     * Get breadcrumbs for product
     *
     * @param {Object} product Product breadcumbs items
     * @param prevCategoryId
     * @return {Array<Object>} Breadcrumbs array
     * @memberof BreadcrumbsDispatcher
     */
    _getProductBreadcrumbs(product, prevCategoryId = null) {
        const { categories, url, name, brand, attributes } = product;
        let brandChanel = attributes?.brand?.attribute_value
        && attributes.brand.attribute_options[attributes.brand.attribute_value]?.label === BRAND_CHANEL ?
            attributes.brand.attribute_options[attributes.brand.attribute_value]?.label : null;

        if (!categories) {
            return [];
        }

        if (!categories.length) {
            return [{ url, name }];
        }

        let breadCrumbs = [
            { url, name },
            ...this._getCategoryBreadcrumbs(
                this.findCategoryById(categories, prevCategoryId)
                || this.findLongestBreadcrumbs(categories)
            )
        ];

        if(BRAND_CHANEL === brandChanel){
            breadCrumbs.push({
                name : "Chanel",
                url : appendWithStoreCode('brand/chanel')
            })
        }

        return breadCrumbs;
    }
}

export default new BreadcrumbsDispatcher();
